import { CustomerApplicationForm } from "Hooks/Api/apiCustomerApplications";
import { CountryCode } from "Models/Enums/CountryCodeEnum";
import { isPhone } from "Validators/Functions/Custom";
import { isEmail } from "Validators/Functions/Email";
import { BusinessNumberGuards } from "Views/Components/BusinessNumberInputs/BusinessValidationModel";

function validateField(
	model: CustomerApplicationForm,
	fieldName: string | number,
	extraDetails?: {
		sendToApplicant: boolean,
		jurisdiction:CountryCode
	}
): string | null {
	const {
		sendToApplicant
	} = extraDetails ?? {};

	switch (fieldName) {
		case 'abn': {
			if (model.abn) return BusinessNumberGuards.invalidAbnLength(model.abn) ? "Invalid ABN" : null;
			if (extraDetails?.sendToApplicant != true && extraDetails?.jurisdiction == "AU" && !model.abn) return "Entity information is required for assessment";
			return null;
		}
		case 'acn': return null;
		case 'trusteeAcn': return null;
		case 'nzbn': {
			if (model.nzbn) return model.nzbn.length !== 13 ? "Invalid NZBN" : null;
			if (extraDetails?.sendToApplicant != true && extraDetails?.jurisdiction == "NZ" && !model.nzbn) return "Entity information is required for assessment";
			return null;
		}
		case 'ncn': return null;
		case 'trusteeNcn': return null;

		case 'businessId': {
			return !model.businessId ? "Business entity is required" : null;
		}
		case 'customerApplicationTemplateId': {
			if (!model.customerApplicationTemplateId) return 'Customer Application Template is required';
			return null;
		}
		case 'ownerId': return !model.ownerId ? "Owner is required" : null;
		case 'reassignedUserId': return null; // Assumed to be userId if none is re-assigned

		// Send to applicant fields
		case 'applicantFirstName': return sendToApplicant ? (!model.applicantFirstName ? "Applicant first name is required" : null) : null;
		case 'applicantLastName': return sendToApplicant ? (!model.applicantLastName ? "Applicant last name is required" : null) : null;
		case 'applicantEmail': {
			if (!sendToApplicant) return null;
			// required if sending to applicant
			if (!model.applicantEmail) return "Applicant email is required";
			if (!isEmail(model.applicantEmail)) return "Invalid email format"
			return null;
		}
		case 'applicantPhone': {
			if (model.applicantPhone && !isPhone(model.applicantPhone)) return "Invalid phone format"
			return null;
		}

		case 'applicantCcEmail': {
			if (model.applicantCcEmail && !isEmail(model.applicantCcEmail)) return "Invalid email format"
			return null;
		}
		case 'sendToApplicant': return null;
		case 'notes': return null;

		default: throw new Error(`Validation on field '${fieldName}' has not been implemented.`);
	}
}

export const CustomerApplicationFormExtensions = {
	// List of fields on CustomerApplicationEntity that are modifable
	modfiableFields: [
		// Business numbers
		'abn', 'acn', 'trusteeAcn', 
		'nzbn', 'ncn', 'trusteeNcn',

		// Form details
		'businessId', 'customerApplicationTemplateId',
		'ownerId', 'reassignedUserId',

		// Ui details
		'sendToApplicant',

		// Applicant details
		'applicantFirstName', 'applicantLastName', 'applicantEmail', 'applicantPhone', 'applicantCcEmail',
	] as (keyof CustomerApplicationForm)[],

	// Returns error message or null if theres no error
	validateField: validateField
}
